import { MapPin, Mail, Linkedin } from "lucide-react";

const ContactInfo = () => {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl md:text-3xl font-bold mb-6">Contact Information</h2>
        <p className="text-muted-foreground mb-8">
          We're here to help you navigate the world of AI and unlock new opportunities for your business.
        </p>
      </div>

      <div className="space-y-6">
        {/* Address */}
        <div className="flex items-start gap-4">
          <div className="mt-1 p-3 rounded-lg bg-primary/10">
            <MapPin className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold mb-1">Office Address</h3>
            <p className="text-muted-foreground">
              Malmskillnadsgatan 36<br />
              111 57 Stockholm<br />
              Sweden
            </p>
          </div>
        </div>

        {/* Email */}
        <div className="flex items-start gap-4">
          <div className="mt-1 p-3 rounded-lg bg-primary/10">
            <Mail className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold mb-1">Email</h3>
            <a 
              href="mailto:info@ailabbet.com"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              info@ailabbet.com
            </a>
          </div>
        </div>

        {/* LinkedIn */}
        <div className="flex items-start gap-4">
          <div className="mt-1 p-3 rounded-lg bg-primary/10">
            <Linkedin className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold mb-1">LinkedIn</h3>
            <a 
              href="https://www.linkedin.com/company/ai-labbet/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              Follow us on LinkedIn
            </a>
          </div>
        </div>
      </div>

      {/* Business Info Card */}
      <div className="mt-8 p-6 bg-card border border-border rounded-lg">
        <h3 className="font-semibold mb-2">AI LAB SWEDEN AB</h3>
        <p className="text-sm text-muted-foreground">
          Organization number: 559415-2919
        </p>
      </div>
    </div>
  );
};

export default ContactInfo;
